import { render, staticRenderFns } from "./comTypeModel.vue?vue&type=template&id=0c8fcaa5&scoped=true&"
import script from "./comTypeModel.vue?vue&type=script&lang=js&"
export * from "./comTypeModel.vue?vue&type=script&lang=js&"
import style0 from "./comTypeModel.vue?vue&type=style&index=0&id=0c8fcaa5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8fcaa5",
  null
  
)

export default component.exports